import React, { useContext } from 'react';
import { Form, Typography, Divider, Card, Space, Menu } from 'antd';
import { ApplicationUIContext, ButtonGroup } from '@yuhuinc/ui-library';
import { StyledHeader } from '../common/Styles';
import { generateBaseApplicationFormInitialValues } from '../common/helpers';
import { getTranslatedString } from 'helpers/i18n';
import { CurrentApplicationContext } from '../ApplicationOverview';
import ReAssignLease from './overview/ReAssignLease';
import Stats from './overview/Stats';
import LeaseDetailsForm from './lease_details/Form';
import { wipAction } from '../common/actions/WipModal';

const translate = (key) =>
  getTranslatedString(`landlordPortal.applicationManagement.leaseOverview.${key}`);

const { Title } = Typography;

const LeaseDetails = () => {
  const currentApplication = useContext(CurrentApplicationContext);
  const { isMobile } = useContext(ApplicationUIContext);
  const [leaseDetailsForm] = Form.useForm();

  // TODO: Change these values
  const canSaveDraft = true;
  const canShowPreview = true;
  const canSendForSignatures = true;
  const canRequestReview = true;
  const canCancelApplication = true;

  const initialFormValues = {
    ...generateBaseApplicationFormInitialValues(currentApplication),
    leaseholders: [...currentApplication.cotenants, ...currentApplication.additional_occupants],
    services_and_utilities: currentApplication.property?.services_and_utilities || {},
  };

  return (
    <Card style={{ maxWidth: 824 }}>
      <StyledHeader>
        <Title level={isMobile ? 3 : 4}>{translate('leaseDetails.cardTitle')}</Title>
        <ButtonGroup
          buttons={[
            canSaveDraft && {
              label: translate('leaseDetails.buttons.saveDraft'),
              type: 'primary',
              onClick: wipAction,
            },
            canShowPreview && {
              label: translate('leaseDetails.buttons.showPreview'),
              onClick: wipAction,
            },
            canSendForSignatures && {
              label: translate('leaseDetails.buttons.sendForSignatures'),
              onClick: wipAction,
            },
          ].filter(Boolean)}
          dropdownOverlay={
            <Menu
              items={[
                canRequestReview && {
                  key: 'request_review',
                  label: translate('leaseDetails.buttons.requestReview'),
                  onClick: wipAction,
                },
                canCancelApplication && {
                  key: 'cancel_application',
                  label: translate('leaseDetails.buttons.cancelApplication'),
                  onClick: wipAction,
                },
              ].filter(Boolean)}
            />
          }
        />
      </StyledHeader>

      <Divider />

      <Space direction="vertical" size="middle">
        <Stats />
        <ReAssignLease />
      </Space>

      <Divider />

      <LeaseDetailsForm
        form={leaseDetailsForm}
        formInitialValues={initialFormValues}
        onSubmit={() => {}}
        editable={!canSaveDraft}
      />
    </Card>
  );
};

export default LeaseDetails;
